import {
  SystemCatalogCategory,
  SystemCatalogItem,
} from '@/queries/system_catalog/system_catalog.schema'
import CategoryList from './_components/CategoryList/CategoryList'
import SystemCatalogItemsTable from './_components/ItemsTable/ItemsTable'

type Props = {
  categories: SystemCatalogCategory[]
  items: SystemCatalogItem[]
  invalidateCategories: () => void
  invalidateItems: () => void
}

function SystemCatalogView(props: Props) {
  const { categories, items, invalidateCategories, invalidateItems } = props
  function handleCategoryChange() {
    invalidateCategories()
  }

  return (
    <div className="flex gap-4 h-full">
      <div className="h-full basis-4/12">
        <CategoryList
          invalidateCategories={invalidateCategories}
          categories={categories}
          onCategoryChange={handleCategoryChange}
        />
      </div>
      <div className="h-full basis-8/12">
        <SystemCatalogItemsTable
          categories={categories}
          invalidateCategories={invalidateCategories}
          invalidateItems={invalidateItems}
          items={items}
        />
      </div>
    </div>
  )
}

export default SystemCatalogView
